import { envService } from "../services/api/envService";

// Detect if running locally (localhost or 127.0.0.1)
const isLocalDevelopment = (): boolean => {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        return hostname === 'localhost' || hostname === '127.0.0.1';
    }
    return false;
};

// Extract base URL properly
const getApiOrigin = (url: string): string => {
    try {
        const urlObj = new URL(url);
        return `${urlObj.protocol}//${urlObj.host}`;
    } catch {
        return url;
    }
};

// Check enabling Middleware based on environment
const isMiddlewareEnabled = (): boolean => {
    const env = envService.env;
    return env === 'prod' || env === 'stage' || env === 'dev';
};

// Get Middleware target URL based on environment
const getMiddlewareTarget = (): string => {
    const env = envService.env;
    if (env === 'prod') return 'https://sryce.middleware.io';
    if (env === 'stage') return 'https://sryce-lvs.middleware.io';
    return 'https://sryce-ufg.middleware.io'; // dev
};

// Get Middleware account key based on environment
const getMiddlewareAccountKey = (): string => {
    return import.meta.env.VITE_MW_ACCOUNT_KEY; // dev
};

// Get Middleware project name based on environment
const getMiddlewareProjectName = (): string => {
    const env = envService.env;
    if (env === 'prod') return 'Visitors-web';
    if (env === 'stage') return 'Visitors-web';
    return 'Visitors-web'; // dev
};

export const environment = {
    apiBaseUrl: import.meta.env.VITE_API_URL || 'http://localhost:4200',
    apiOrigin: getApiOrigin(import.meta.env.VITE_API_URL || 'http://localhost:4200'),
    environment: envService.env || 'dev',
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    middleware: {
        // Middleware is DISABLED for local development to avoid noise
        enabled: isMiddlewareEnabled() && !isLocalDevelopment(),
        accountKey: getMiddlewareAccountKey(),
        target: getMiddlewareTarget(),
        serviceName: 'Visitors-web',
        projectName: getMiddlewareProjectName(),
        env: envService.env || 'dev',
        version: import.meta.env.VITE_APP_VERSION || '1.0.0',
        // RUM/Session recording disabled by default - only traces are captured
        // Call middlewareService.enableSessionRecording() to enable on demand
        sessionRecording: false,
    },
};
